import template from './location.edit.html';
import controller from './location.edit.controller';
import './location.edit.scss';

let locationeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default locationeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/edit/location.edit.component.js